export const CellularIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.3485 16.305C0.972333 16.305 0.6535 16.1736 0.392 15.9107C0.130667 15.6479 0 15.3287 0 14.9532V11.806C0 11.429 0.131834 11.1085 0.3955 10.8445C0.659334 10.5805 0.979667 10.4485 1.3565 10.4485C1.73333 10.4485 2.053 10.5805 2.3155 10.8445C2.578 11.1085 2.70925 11.429 2.70925 11.806V14.9532C2.70925 15.3287 2.57692 15.6479 2.31225 15.9107C2.04775 16.1736 1.7265 16.305 1.3485 16.305ZM7.62625 16.305C7.24942 16.305 6.93083 16.1736 6.6705 15.9107C6.41 15.6479 6.27975 15.3287 6.27975 14.9532V6.806C6.27975 6.429 6.41125 6.1085 6.67425 5.8445C6.93725 5.5805 7.25658 5.4485 7.63225 5.4485C8.00792 5.4485 8.327 5.5805 8.5895 5.8445C8.85183 6.1085 8.983 6.429 8.983 6.806V14.9532C8.983 15.3287 8.85108 15.6479 8.58725 15.9107C8.32358 16.1736 8.00325 16.305 7.62625 16.305ZM13.9025 16.305C13.5262 16.305 13.2073 16.1736 12.9458 15.9107C12.6844 15.6479 12.5537 15.3287 12.5537 14.9532V1.35775C12.5537 0.980583 12.6857 0.659999 12.9495 0.395999C13.2132 0.131999 13.5335 0 13.9105 0C14.2873 0 14.6069 0.131999 14.8692 0.395999C15.1317 0.659999 15.263 0.980583 15.263 1.35775V14.9532C15.263 15.3287 15.1307 15.6479 14.866 15.9107C14.6015 16.1736 14.2803 16.305 13.9025 16.305Z"
        fill="currentColor"
      />
    </svg>
  );
};
